var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1478px",
    height: "539px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1478 539",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_551607000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0B6EC7",
    fillRule: "nonzero",
    d: "M1261 70l-65 0 0 276 81 0 0 -177c25,-15 59,-28 103,-27l0 -78c-48,2 -82,18 -110,36l-9 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B6EC7",
    fillRule: "nonzero",
    d: "M818 70l-85 0 0 -70 -69 0 -9 70 -50 0 0 65 46 0 0 122c0,72 48,95 106,95 25,0 41,-2 61,-10l0 -64c-14,5 -34,7 -44,7 -33,0 -41,-16 -41,-43l0 -107 85 0 0 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B6EC7",
    fillRule: "nonzero",
    d: "M471 64c-79,0 -136,24 -136,84 0,36 13,67 74,80l60 12c37,8 42,15 42,24 0,15 -13,23 -63,23 -37,0 -88,-13 -107,-19l0 67c22,7 73,17 110,17 102,0 140,-38 140,-90 0,-42 -23,-68 -81,-81l-56 -12c-33,-8 -40,-8 -40,-21 0,-18 38,-20 62,-20 29,0 60,6 98,19l0 -65c-24,-9 -59,-18 -103,-18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B6EC7",
    fillRule: "nonzero",
    d: "M139 64c-41,0 -91,6 -116,14l0 66c29,-8 58,-16 91,-16 52,0 86,12 86,51l0 11c-34,-13 -63,-15 -85,-15 -52,0 -115,20 -115,85 0,52 40,92 110,92 50,0 84,-20 100,-30l8 24 63 0 0 -168c0,-86 -61,-114 -142,-114zm-55 198c0,-20 16,-33 50,-33 29,0 51,4 66,12l0 33c-16,8 -39,19 -65,19 -34,0 -51,-13 -51,-31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B6EC7",
    fillRule: "nonzero",
    d: "M1142 238l0 -38c0,-87 -47,-136 -138,-136 -79,0 -153,45 -153,142 0,102 64,146 162,146 41,0 82,-9 114,-20l0 -63c-29,9 -72,19 -111,19 -32,0 -77,-9 -82,-50l208 0zm-207 -51c4,-41 30,-59 69,-59 35,0 54,22 55,59l-124 0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F6D106",
    cx: 910,
    cy: 480,
    r: 59
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F6D106",
    cx: 1078,
    cy: 480,
    r: 59
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F6D106",
    cx: 1250,
    cy: 480,
    r: 59
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F6D106",
    cx: 1419,
    cy: 480,
    r: 59
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b39bb6096ca5b22ddd0af79db2253928.svg";
export { ForwardRef as ReactComponent };